import { giphyBlack } from '@giphy/js-brand'
import { useContext } from 'react'
import { UgeEditorContext } from '../../contexts/editor'
import { UgeLayersContext } from '../../contexts/layers'
import { Layer } from '../../types'
import UgeLayerAction, {
    layerActionGradient,
    layerActionIconName,
    layerActionName,
    ugeLayerActions,
} from '../../types/layer-action'
import Attribution from './attribution'
import { Menu, MenuItem, MenuItemIcon, MenuItemLabel } from './style'

type Props = {
    className?: string
    layer: Layer
    onAfterAction?: () => void
}

const UgeLayerContextMenu = ({ className, layer, onAfterAction }: Props) => {
    const { performLayerAction } = useContext(UgeLayersContext)
    const { openEditor } = useContext(UgeEditorContext)

    const onAction = (action: UgeLayerAction) => {
        performLayerAction(layer, action)
        onAfterAction?.()
    }

    const onTimingClick = () => {
        openEditor('layers', { layerId: layer.id })
        onAfterAction?.()
    }

    const onStickerSearch = (searchTerm?: string) => {
        openEditor('stickers', { searchTerm })
        onAfterAction?.()
    }

    return (
        <div className={className}>
            {layer.user && <Attribution user={layer.user} onSearch={onStickerSearch} />}
            <Menu>
                <MenuItem onClick={onTimingClick}>
                    <MenuItemLabel color={giphyBlack} size="medium">
                        Timing
                    </MenuItemLabel>
                    <MenuItemIcon gradient="blue-green" icon="clock" iconScale={0.8} inverted size="medium" />
                </MenuItem>
                {ugeLayerActions.map((action) => (
                    <MenuItem key={`layer-context-menu-${action}`} onClick={() => onAction(action)}>
                        <MenuItemLabel color={giphyBlack} size="medium">
                            {layerActionName(action)}
                        </MenuItemLabel>
                        <MenuItemIcon
                            gradient={layerActionGradient(action)}
                            icon={layerActionIconName(action)}
                            iconScale={0.8}
                            inverted
                            size="medium"
                        />
                    </MenuItem>
                ))}
            </Menu>
        </div>
    )
}

export default UgeLayerContextMenu
